// @ts-nocheck
import trackViewPromotion, {
    TrackViewPromotionParameters,
} from "@store/Framework/Common/GoogleAnalytics/trackers/trackViewPromotion";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackViewPromotion = (
    parameters: PartialSpecific<TrackViewPromotionParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return (
        callParameters: Partial<TrackViewPromotionParameters> = {},
        callOptions?: Toolkit.GoogleAnalytics.Options,
    ) => {
        return trackViewPromotion({ ...parameters, ...callParameters }, { ...options, ...callOptions });
    };
};

export default useTrackViewPromotion;
